const messages = {
  newAccount: {
    title: '¡Cuenta creada con éxito!',
    body: '¡Tu cuenta fue creada con éxito! Ya puedes disfrutar lo mejor de Riivi y guardar tus películas y series favoritas.'
  },
};

export default () => messages;
